const isValidPriceValue = (priceValue?: string | number): boolean => {
  return priceValue !== undefined && priceValue !== "";
};

export default isValidPriceValue;
